module.exports = __webpack_public_path__ + "img/Avatar.211b8230.svg";